export default __webpack_public_path__ + "static/media/feel-the-luxury.e109d3b5.webp";